/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { PdfSection } from './pdf-section';
import { TranslateService } from '@ngx-translate/core';
import { PdfHeader } from '../pdf-header';
import { PdfUtils } from '../pdf-utils';
import { NameValue } from '../../tool/name-value';

export class ChecklistPdfSection extends PdfSection {
  private columns: number;
  private checkboxes: NameValue[];
  constructor(title: string, columns: number, checkboxes: NameValue[]) {
    super(title);
    this.columns = columns;
    this.checkboxes = checkboxes;
  }
  build(
    trl: TranslateService,
    doc,
    header: PdfHeader,
    x: number,
    y: number
  ): number {
    const maxHeight = doc.internal.pageSize.getHeight() - 30;
    doc.setDrawColor(47, 55, 58);
    doc.setTextColor(47, 55, 58);
    doc.setFontSize(10);
    const x2 = doc.internal.pageSize.getWidth() - 30 - x;
    let newY = y + this.margin.h;
    let newX = x + this.margin.w;
    const rowHeight = doc.getTextDimensions('To').h;
    const columnWidth = Math.ceil((x2 - 50) / this.columns);
    for (let index = 0; index < this.checkboxes.length; ) {
      for (let i = 0; i < this.columns && index < this.checkboxes.length; ++i) {
        // row loop
        const checkbox = this.checkboxes[index];
        doc.rect(newX, newY - 8, 10, 10);
        if (checkbox.value) {
          doc.text(newX + 2, newY + 1, 'X');
        }
        checkbox.name = trl.instant(checkbox.name);
        doc.setFont('roboto', 'bold');
        doc.text(newX + 13, newY, checkbox.name);
        doc.setFont('roboto', 'normal');
        newX += columnWidth + this.margin.w;
        ++index;
      }
      newY += rowHeight + 5;
      newX = x + this.margin.w;
      if (newY + rowHeight + this.margin.h * 2 > maxHeight) {
        doc.rect(x, y, x2, newY - y - 5); // Rect logo
        PdfUtils.addPage(doc, header);
        y = header.height;
        newY = header.height + this.margin.h;
      }
    }
    doc.rect(x, y, x2, newY - y - 5); // Rect logo
    return newY - 10;
  }

  getDimension(doc: unknown): { w: number; h: number } {
    void doc;
    return { h: 0, w: 0 };
  }
}
